// Le barre per giorno dei grafici della Dashboard: l'ultima (oggi) più accesa. Ogni barra dice
// il suo valore al passaggio.
export function Bars({
  values,
  days,
  height,
  color = 'var(--accent)',
  muted = false,
  rainbow = false,
  format,
}: {
  values: number[];
  days: string[];
  height: number;
  color?: string;
  muted?: boolean;
  /** una tinta pop per barra, come le caramelle della tela */
  rainbow?: boolean;
  format: (v: number) => string;
}) {
  const top = Math.max(...values, 1);
  return (
    <div
      role="img"
      aria-label={`Ultimi ${values.length} giorni, oggi ${format(values[values.length - 1] ?? 0)}`}
      style={{ height, display: 'flex', alignItems: 'flex-end', gap: rainbow ? 10 : 3 }}
    >
      {values.map((v, i) => (
        <span
          key={days[i] ?? i}
          title={`${days[i]}: ${format(v)}`}
          style={{
            flex: 1,
            height: v ? `${Math.max((v / top) * 100, 4)}%` : 2,
            background: v ? (rainbow ? `var(--ses-${(i % 6) + 1})` : color) : 'var(--border)',
            opacity: v ? (muted ? 0.45 : rainbow || i === values.length - 1 ? 1 : 0.7) : 1,
            borderRadius: rainbow ? '12px 12px 6px 6px' : 2,
            boxShadow: rainbow && v ? 'inset 0 -5px 0 rgba(0, 0, 0, 0.12)' : undefined,
          }}
        />
      ))}
    </div>
  );
}
